/**
 * ViewerVariantToggle — 2D / 3D viewer variant switcher.
 *
 * Visible whenever the project has render_top enabled (capabilities.allowsThreeDVariant).
 * The 3D button is disabled when the active mode doesn't support the 3D variant
 * (e.g. ARRANGE mode is 2D only).
 *
 * Dev stub UI — uses plain <button> elements. Swap for shared Button / ButtonGroup
 * once the shared component supports aria-pressed group semantics.
 */

import { useI18n } from '../../../../shared/i18n/useI18n.js'

import { useProduct } from '../../index.js'

import { VIEWER_VARIANT, VIEWER_VARIANT_LABEL_KEYS } from '../../constants/viewerVariant.js'

import { Button, ButtonGroup } from '../../../../shared/ui/Button/index.js'

import styles from './ViewerVariantToggle.module.scss'

// ── Component ─────────────────────────────────────────────────────────────────

export function ViewerVariantToggle({
  isMobile,
}) {
  const { t } = useI18n()
  const { modes, capabilities } = useProduct()
  const { activeViewerVariant, availableViewerVariants, setViewerVariant } = modes

  if (!capabilities.allowsThreeDVariant) return null

  return (
    <div className={styles.variantToggleBox}>
      <span className={styles.label}>
        {t('product.viewer_variant_label')}
      </span>
      <ButtonGroup 
        size={isMobile ? "medium" : "large"}
        sliding
        aria-label={t('product.viewer_variant_label')}>
        {[VIEWER_VARIANT._2D, VIEWER_VARIANT._3D].map((variant) => {
          const isActive   = activeViewerVariant === variant
          const isDisabled = !availableViewerVariants.includes(variant)

          return (
            <Button
              key={variant}
              type="button"
              kind="text"
              size={isMobile ? "medium" : "large"}
              selected={isActive}
              onClick={() => setViewerVariant(variant)}
              disabled={isDisabled}
              aria-pressed={isActive}
            >
              {t(VIEWER_VARIANT_LABEL_KEYS[variant])}
            </Button>
          )
        })}
      </ButtonGroup>
    </div>
  )
}
